module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNjI3NjggNC41MTAyQzkuMjk0MzUgNC44OTUxIDkuMjk0MzUgNS44NTczNiA4LjYyNzY5IDYuMjQyMjZMMi4wMDI2OSAxMC4wNjcyQzEuMzM2MDIgMTAuNDUyMSAwLjUwMjY4NyA5Ljk3MDk4IDAuNTAyNjg3IDkuMjAxMThWMS41NTEyOUMwLjUwMjY4NyAwLjc4MTQ4NiAxLjMzNjAyIDAuMzAwMzU5IDIuMDAyNjkgMC42ODUyNkw4LjYyNzY4IDQuNTEwMloiIGZpbGw9IiM1MjUyNTIiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/account/play.svg
// module id = 9694
// module chunks = 0